export default __webpack_public_path__ + "static/media/lightspeed-icon.2dee88b9.png";